import axios from 'utils/axios';
import { put } from 'redux-saga/effects';
import * as Notifications from 'actions/Notifications';
import { toastr } from 'react-redux-toastr'
import i18n from 'i18n/i18n.js';

export function* onRegisterDeviceRequest({ payload }) {
  try {
    yield axios.post(`/api/app/setWebDeviceToken`, JSON.stringify(payload) );
    yield put(Notifications.onRegisterDeviceSuccess(payload || ""));
  } catch (e) {
    yield put(Notifications.onRegisterDeviceFailure({ message: e.toString(), error: e }));
  }
}

export function* onGetNotificationsRequest({ payload }) {
  const { size, page } = payload || { size: 5, page: 0 }
  try {
    const res = yield axios.get(`/api/hitNotification/get?sort=created,desc&size=${size||10}&page=${page||0}`);
    yield put(Notifications.onGetNotificationsSuccess(res.data));
  } catch (e) {
    yield put(Notifications.onGetNotificationsFailure({ message: e.toString(), error: e }));
  }
}

export function* onSetNotificationClickedRequest({ payload }) {
  try {
    const res = yield axios.post(`/api/notification/setClicked`, payload);
    yield put(Notifications.onSetNotificationClickedSuccess(res.data || []));
  } catch (e) {
    yield put(Notifications.onSetNotificationClickedFailure({ message: e.toString(), error: e }));
  }
}

export function* onNotificationPollRequest() {
  try {
    const response = yield axios.get('/api/status/app/v3/poll');
    yield put(Notifications.onPollSuccess(response.data || []));
  } catch (error) {
    yield put(Notifications.onPollFailure({ message: error }));
  }
}

export function* onSendPushNotificationRequest({ params, cb }) {

  const data = new FormData();

  data.append('message', params.message);
  data.append('studentIds', params.studentIds);
  data.append('hitClubId', params.hitClubId);
  
  try {
    const res = yield axios.post(`/api/hitClub/pushMessageToStudents`, data);
    toastr.success(i18n.t('toastr.onSendPushNotificationRequest.title'), i18n.t('toastr.onSendPushNotificationRequest.body', { count: params.count }))
  } catch (e) {
    yield put(Notifications.onGetNotificationsFailure({ message: e.toString(), error: e }));
  }
}

export function* onSendPushNotificationToHitClubRequest({ params, cb }) {

  const data = new FormData();

  data.append('message', params.message);
  data.append('hitClubId', params.hitClubId);
  
  try {
    const res = yield axios.post(`/api/hitClub/pushMessageToHitClub`, data);
    toastr.success(i18n.t('toastr.onSendPushNotificationToHitClubRequest.title'), i18n.t('toastr.onSendPushNotificationToHitClubRequest.body'))
  } catch (e) {
    yield put(Notifications.onGetNotificationsFailure({ message: e.toString(), error: e }));
  }
}

export function* onSendPushNotificationToHitClubExpiredRequest({ params, cb }) {

  const data = new FormData();

  data.append('message', params.message);
  data.append('hitClubId', params.hitClubId);
  data.append('numberOfMonths', params.numberOfMonths);
  
  try {
    const res = yield axios.post(`/api/hitClub/pushMessageToHitClubExpired`, data);
    toastr.success(i18n.t('toastr.onSendPushNotificationToHitClubExpiredRequest.title'), i18n.t('toastr.onSendPushNotificationToHitClubExpiredRequest.body', { number: params.numberOfMonths }))
  } catch (e) {
    yield put(Notifications.onGetNotificationsFailure({ message: e.toString(), error: e }));
  }
}